import { render, staticRenderFns } from "./StatsHome.vue?vue&type=template&id=37d0e7e1&scoped=true"
import script from "./StatsHome.vue?vue&type=script&lang=js"
export * from "./StatsHome.vue?vue&type=script&lang=js"
import style0 from "./StatsHome.vue?vue&type=style&index=0&id=37d0e7e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d0e7e1",
  null
  
)

export default component.exports